module.exports = __webpack_public_path__ + "media/images/subject_img/AGRICULTURE-34f4a11059aeff0b455afe8e9738926f.jpg";